var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Generate AWB")])])])]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group row",
    attrs: {
      "name": "checkForm"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Client")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user' style='font-size: 12px'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.Clientlist,
      "name": "CompanyList",
      "placeholder": "Select Client Name",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true
    },
    on: {
      "select": _vm.selectClient
    },
    model: {
      value: (_vm.client),
      callback: function($$v) {
        _vm.client = $$v
      },
      expression: "client"
    }
  }), _vm._v("\n                  \n              ")], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('CompanyList')),
      expression: "errors.has('CompanyList')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please select client name.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Route Mode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('div', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RouteMode),
      expression: "RouteMode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "Surface",
      "value": "Surface",
      "name": "RouteMode"
    },
    domProps: {
      "checked": _vm._q(_vm.RouteMode, "Surface")
    },
    on: {
      "__c": function($event) {
        _vm.RouteMode = "Surface"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "Surface"
    }
  }, [_vm._v("Surface ")]), _vm._v("\n                     \n              ")]), _vm._v(" "), _c('div', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RouteMode),
      expression: "RouteMode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "Air",
      "value": "Air",
      "name": "RouteMode"
    },
    domProps: {
      "checked": _vm._q(_vm.RouteMode, "Air")
    },
    on: {
      "__c": function($event) {
        _vm.RouteMode = "Air"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "Air"
    }
  }, [_vm._v("Air")])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('RouteMode')),
      expression: "errors.has('RouteMode')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Route Mode field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("AWB Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('div', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbtype),
      expression: "awbtype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "AWB",
      "value": "AWB",
      "name": "awbtype"
    },
    domProps: {
      "checked": _vm._q(_vm.awbtype, "AWB")
    },
    on: {
      "__c": function($event) {
        _vm.awbtype = "AWB"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "awb"
    }
  }, [_vm._v("AWB ")]), _vm._v("\n                     \n              ")]), _vm._v(" "), _c('div', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbtype),
      expression: "awbtype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "MPS",
      "value": "MPS",
      "name": "awbtype"
    },
    domProps: {
      "checked": _vm._q(_vm.awbtype, "MPS")
    },
    on: {
      "__c": function($event) {
        _vm.awbtype = "MPS"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "mps"
    }
  }, [_vm._v("MPS")])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('awbtype')),
      expression: "errors.has('awbtype')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The AwbType field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Number of MPS")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-wpforms' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mpsNo),
      expression: "mpsNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "mpsNo",
      "id": "mpsNo",
      "placeholder": "Enter No. of MPS",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.mpsNo)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mpsNo = $event.target.value
      }
    }
  })]), _vm._v("\n              \n          "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mpsNo')),
      expression: "errors.has('mpsNo')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('mpsNo')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-primary",
    class: {
      'form-control': false
    },
    attrs: {
      "type": "submit",
      "title": "SUBMIT"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.generateAWB($event)
      }
    }
  }, [_vm._v("GENERATE AWB")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Client AWB Count List")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b', {
    staticStyle: {
      "float": "right",
      "padding-top": "5px"
    }
  }, [_vm._v("Total Records: " + _vm._s(_vm.totalCount))])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Client Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Surface Awb Count")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Air Awb Count")])]), _vm._v(" "), _vm._l((_vm.tableItems), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ClientId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ClientName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.SurfaceAWBCount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.AirAWBCount))])])
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Child MPS Count List")])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Route Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Count")])]), _vm._v(" "), _vm._l((_vm.mpsresult), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.routemode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.count))])])
  })], 2)])])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06bad361","hasScoped":true}!./src/modules/cargobooking/views/booking/generateClientAwb/generateClientAwb.component.html
// module id = 1204
// module chunks = 3